const THREE = require('three')
import {TimelineMax, Cubic, SlowMo} from 'gsap'
import {CanvasTextWrapper} from 'src/lib/canvas-text-wrapper.js'
import {perfectZ} from '../camera-ui'
import sounds from '../sounds'
// import raf from 'raf'


let geometry = new THREE.PlaneBufferGeometry( 250, 250, 1 )

let canvas = document.createElement('canvas')
// canvas.setAttribute('style', 'opacity: 0; z-index: -1; position: relative;')
// document.body.appendChild(canvas)

let texture = new THREE.Texture(canvas)
let material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true,
  side: THREE.DoubleSide,
  alphaTest: 0.01
})
// let material = new THREE.MeshNormalMaterial()
// material.depthTest = true
// material.depthWrite = false


export let mesh = new THREE.Mesh( geometry, material )

// const s = 0.1
// mesh.scale.set(s, s, s)
// mesh.rotation.y = -180 * Math.PI / 180
mesh.name = 'textCanvas'


export const reset = function() {
  if (mesh.tl) {
    mesh.tl.pause(0, true)
    mesh.tl.remove()
  }
  let ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
}

export let draw = (string, fontsize)=> {
  return new Promise((resolve)=> {
    if (!fontsize) fontsize = 50

    texture.needsUpdate = true

    // draw text on canvas
    let ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.canvas.width = 512
    ctx.canvas.height = 512
    ctx.fillStyle = '#FFFFFF'
    ctx.font = `${fontsize}px FoS`
    // speedEffectText(string, 0, 100, ctx, fontsize)
    CanvasTextWrapper(canvas, string.toUpperCase(), {
      font: ctx.font,
      textAlign: 'center',
      verticalAlign: 'middle',
      paddingY: 10
    })

    // entering/leaving animations
    mesh.position.z = -perfectZ
    // mesh.position.y = 0.5
    // mesh.position.z = -1
    mesh.material.opacity = 0



    if (mesh.tl) {
      mesh.tl.kill()
    }
    let tl = new TimelineMax({onComplete: ()=> {
      resolve()
    }})
    let time = 1.2
    tl
      .to(mesh.position, time, {
        z: perfectZ,
        ease: SlowMo.ease.config(0.8, 0.4),
        onStart: ()=> {
          sounds.text.audio.play()
        }
      })
      .to(mesh.material, time, {
        opacity: 1,
        ease: SlowMo.ease.config(0.8, 0.4, true),
        onUpdate: ()=> { mesh.material.needsUpdate = true }
      }, `-=${time}`)
    mesh.tl = tl

    // setTimeout(()=> {
    //   resolve()
    // }, 3000)
  })
}

export default draw




// WEBPACK FOOTER //
// ./src/components/game/ui/text-simple.js